import { Loader2, Wrench } from "lucide-react";

interface ToolCallBlockProps {
  name: string;
  args: string;
  result?: string;
}

export function ToolCallBlock({ name, result }: ToolCallBlockProps) {
  const isPending = result === undefined;

  return (
    <div className="my-2 rounded-lg border border-black/10 bg-black/[0.02] dark:border-white/10 dark:bg-white/[0.02]">
      <div className="flex items-center gap-2 px-3 py-2 text-xs font-medium text-black/50 dark:text-white/50">
        <Wrench className="h-3 w-3 shrink-0" />
        <span className="font-mono">{name}</span>
        {isPending && (
          <Loader2 className="h-3 w-3 animate-spin text-brand-coral" />
        )}
      </div>
    </div>
  );
}
